<template>
  <app-toast
    class="resend-sms-toast"
    :message="message"
  >
    <div
      class="toast-body"
      v-html="$t('user.sms-verification.resent')"
    />
  </app-toast>
</template>

<script>
  import appToast from '@/components/app-toast'

  export default {
    name: 'ResendSms',

    components: {
      'app-toast': appToast
    },
    props: {
      message: Object
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .delete-bank-toast {
    strong {
      color: map_get($palette-primary, main);
    }
  }
</style>
